var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeftCircle = function SvgChevronLeftCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.999 5.333C17.295 5.333 5.332 17.296 5.332 32s11.963 26.667 26.667 26.667S58.665 46.704 58.665 32 46.703 5.333 32 5.333m0 48c-11.763 0-21.334-9.57-21.334-21.333S20.236 10.667 32 10.667 53.332 20.237 53.332 32s-9.57 21.333-21.333 21.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.45 16.781 20.23 32l15.22 15.219 3.77-3.771L27.772 32 39.22 20.552z"
  })));
};
export default SvgChevronLeftCircle;